<p-chip
    [label]="label"
    [removable]="removable"
    (onRemove)="onChipRemove()"
    [ngClass]="size"
>
    <ng-template pTemplate="removeicon">
        <lucide-icon name="X"></lucide-icon>
    </ng-template>
</p-chip>